(function(){
  var RX=/\/cart\/(\d+:\d+(?:,\d+:\d+)*)(\?return_to=\/checkout)?$/,busy=false;
  function go(href){
    var m=String(href||'').replace(location.origin,'').match(RX);if(!m){location.href=href;return}
    if(busy)return;busy=true;
    var items=m[1].split(',').map(function(p){p=p.split(':');return{id:+p[0],quantity:+p[1]}});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok)return r.json().then(function(j){throw new Error(j.description||j.message||'Could not add to bag')});return r.json()})
      .then(function(){if(m[2]){checkout();return}
        if(!window.HG_DRAWER){location.href='/cart';return}
        busy=false;restore();HG_DRAWER.open()})
      .catch(function(err){busy=false;restore();alert(err.message)});
  }
  // Fastrr (Shiprocket) checkout for the Shopify cart, exactly as the previous theme: India visitors get
  // Fastrr, everyone else (and any failure) gets Shopify's checkout.
  function checkout(){
    // gifts and the milestone code are settled first so Fastrr / Shopify checkout gets them
    if(window.HG_DRAWER&&!checkout.ready){HG_DRAWER.sync().catch(function(){}).then(function(){checkout.ready=1;checkout();checkout.ready=0});return}
    if(!window.HG_FASTRR){location.href='/checkout';return}
    var t0=Date.now();
    (function wait(){
      if(window.HeadlessCheckout&&HeadlessCheckout.checkout){try{HeadlessCheckout.checkout();busy=false;return}catch(e){}}
      if(Date.now()-t0>4000){location.href='/checkout';return}
      setTimeout(wait,120);
    })();
  }
  // product pages set their button to "One moment…" before calling HG_GO; remember the label to put it back
  var btn=null,label='';
  document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('#add,#now,#stb');if(b){btn=b;label=b.textContent}},true);
  function restore(){if(btn){btn.textContent=label;btn.classList.remove('busy');btn=null}}
  window.HG_GO=go;window.HG_CHECKOUT=checkout;
  // the bag page's Checkout button
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[name="checkout"],a[href="/checkout"]');if(!b||!window.HG_FASTRR)return;
    e.preventDefault();checkout();
  });
  // Plain cart links (reels, "Add both"). Pages that handle the click themselves call preventDefault
  // and then HG_GO, and the sold-out "Notify me" handler stops the event, so both are skipped here.
  document.addEventListener('click',function(e){
    if(e.defaultPrevented)return;
    var a=e.target.closest&&e.target.closest('a[href]');if(!a)return;
    if(!RX.test(a.getAttribute('href')||''))return;
    e.preventDefault();go(a.getAttribute('href'));
  });
  // After a Fastrr order, Fastrr's window asks this page to open Shopify's order page (shopify.com).
  // Open our own order page instead (/pages/order-confirmed). This listener runs before Fastrr's
  // (capture phase); every other Fastrr message, and any redirect that is not an order page, is left alone.
  var ORD=/\/orders\/([0-9a-f]{32})(?:[\/?#]|$)/;
  window.addEventListener('message',function(e){
    if(window.HG_TY_OFF||!/^https:\/\/([a-z0-9-]+\.)*(pickrr\.com|shiprocket\.in|shiprocket\.co)$/.test(e.origin||''))return;
    var d=e.data||{},url='';
    // step log for the order page's ?debug=1 view (no personal data)
    function dl(m){try{var a=JSON.parse(sessionStorage.getItem('hg_ctp_log')||'[]');a.push(new Date().toTimeString().slice(0,8)+' '+m);sessionStorage.setItem('hg_ctp_log',JSON.stringify(a.slice(-40)))}catch(x){}}
    if(d.trigger==='set-cookie'&&d.data&&/Ctp|SellerId/.test(d.data.name||''))dl('checkout saved '+d.data.name);
    if(d.trigger==='headless-redirect-post'&&typeof d.data==='string')url=d.data;
    else if(d.actions&&d.actions.forEach)d.actions.forEach(function(a){
      var u=a&&a.data&&(a.action==='redirectTo'?a.data.url:a.action==='clearCart'?a.data.redirectTo:'');if(u)url=String(u)});
    var m=url.match(ORD);if(!m)return;
    e.stopImmediatePropagation();dl('redirect to our order page');
    var to='/pages/order-confirmed?t='+m[1];
    fetch('/cart/clear.js',{method:'POST'}).catch(function(){}).then(function(){location.href=to});
    setTimeout(function(){location.href=to},2500);
  },true);
})();
